import React, { useEffect, useState, useMemo } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import {
  Card,
  Col,
  Row,
  Tooltip,
  Select,
  Space,
  Form,
  DatePicker,
  Spin,
} from "antd";
import upload from "../../../assets/images/upload.svg";
import styled from "styled-components";
import FilterIcon from "../../../assets/images/Filter-Icon.svg";
import Stack from "react-bootstrap/Stack";
import UITable, {
  StyledTable,
} from "../../../Reusablecomponents/UITable/UITable";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { CALL_API } from "../../../Common/api";
import axios from "axios";
import { useSelector } from "react-redux";
import moment from "moment";
import dayjs from "dayjs";
import { handleDownloadChart } from "../../../Reusablecomponents/Export/Exportpdf";

const Fuelreportstyle = styled.div`
  .head {
    color: #5f6d8c;
  }
  .total {
    display: flex;
    align-items: center;
    justify-content: space-between !important;
  }
  .Custom {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .dropstyle {
    margin-top: 20px !important;
    width: 251px !important;
  }
  .dropstyle1 {
    height: 36px;
    width: 251px !important;
  }
  .badg {
    padding: 5px;
  }
  .badg .ant-badge-count {
    font-size: 12px; /* Adjust the count number size */
    height: 16px; /* Decrease the outer circle height */
    min-width: 16px; /* Decrease the outer circle width */
    line-height: 16px; /* Center the count text vertically */
  }

  .plc .ant-select-selection-placeholder {
    color: black !important; /* Set placeholder text color to black */
  }

  .plc .ant-select-arrow {
    color: black; /* Set dropdown arrow color to black */
  }
.fuel-report-item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top:10px;
  }
  .text-content
  {
    padding:20px;
    line-height=15px;
    text-align:center;
  }
  .vr 
  {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1px;
  background-color: #000;
  margin-left:250px;
  
  }
  .ant-card-head{
border-bottom: none;
}
.Fuel-List{
border: 1px solid #F4F4F4;
border-radius: 5px;
margin:5px
}
// .Fuel-station-content{
// display:flex;

// align-item:center;
// }
`;

//donut chart
const COLORS = [
  "#73B03A",
  "#827EFF",
  "#FFFD69",
  "#FFAD6F",
  "#F870FF",
  "#FFD361",
  "#EB7283",
  "#61FFE5",
  "#FF4F52",
  "#95FF87",
];

const COLORS1 = [
  "#FFD361",
  "#EB7283",
  "#61FFE5",
  "#FF4F52",
  "#95FF87",
  "#73B03A",
  "#827EFF",
  "#FFFD69",
  "#FFAD6F",
  "#F870FF",
];

const FuelsColumn = [
  {
    title: "Fuel Station",
    dataIndex: "DATA",
    key: "DATA",
  },
  // {
  //   title: "Location",
  //   dataIndex: "Location",
  //   key: "Location",
  // },
];

const FuelReportAI = () => {
  const [visible1, setVisible1] = useState(false);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [fuelData, setFuelData] = useState({});
  const [fuelChartData, setFuelChartData] = useState([]);
  const [driverChartData, setDriverChartData] = useState([]);
  const [stationChartData, setStationChartData] = useState([]);
  const [stationData, setStationData] = useState([]);
  const [dateRange, setDateRange] = useState([]);
  const [duration, setDuration] = useState("current_month");
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const vehicleList = useSelector(
    (state) => state?.authTracking?.AIVehicleLists,
  );
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("AIFUELRPT", "EX"),
    [reduxPermissions],
  );
  const FuelVerticalChart = () => {
    return (
      <ResponsiveContainer width="100%" height={380}>
        <BarChart
          layout="vertical"
          margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
          barSize={28}
          data={stationChartData}
        >
          <CartesianGrid vertical={false} horizontal={false} />
          <XAxis type="number" axisLine={false} tickLine={false} />
          <YAxis
            type="category"
            dataKey="DATA"
            axisLine={false}
            tickLine={true}
            tick={{
              fontSize: 12, // Adjust font size if needed
              textAnchor: "end", // Align text to end for better readability
            }}
            label={{
              value: "Litres", // Text you want to display
              angle: 0, // Keep the text horizontal
              position: "bottom", // Position it below the Y-axis labels
              offset: 8, // Adjust spacing
              dx: 5, // Move the text slightly to the right

              style: { fontSize: 14, fill: "#000" }, // Customize text appearance
            }}
          />
          <Tooltip />
          {/* <Legend /> */}
          <Bar
            dataKey="VAL"
            fill="#126DF6"
            radius={5}
            style={{ cursor: "pointer" }}
          >
            <LabelList
              content={({ x, y, width, value }) => (
                <text
                  x={x + width + 5} // 5px padding to the right of the bar
                  y={y + 14} // vertically center the label in the bar
                  fill="#000"
                  fontSize={12}
                >
                  {Math.round(value)}
                </text>
              )}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  };
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    percent,
    outerRadius,
    index,
  }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 1.25; // Adjust the radius for label positioning
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const ishrline = Math.cos(-midAngle * RADIAN) > 0;
    const lineLength = ishrline ? 100 : -100;
    const textOffset = ishrline ? 20 : -20;
    const color = COLORS[index % COLORS.length];
    const squareSize = 12;

    // Mock time value for the label
    //   const timeValue = pieChartData[index].time || "00:60"; // Adjust this key if needed

    return (
      <>
        {/* Anchor line */}
        <line
          x1={x}
          y1={y}
          x2={x + lineLength}
          y2={y}
          stroke="#ccc"
          strokeWidth={1}
        />
        <rect
          x={x + lineLength + (ishrline ? -squareSize - 0 : 0)} // Adjust position
          y={y - squareSize / 2} // Center vertically
          width={squareSize}
          height={squareSize}
          fill={color}
        />
        <text
          x={x + lineLength + textOffset}
          y={y}
          fill="#5F6D8C"
          textAnchor={ishrline ? "start" : "end"}
          dominantBaseline="central"
          fontSize={14}
        >
          {`${
            vehicleList?.find((v) => v.FGUID === fuelChartData[index]?.VEHID)
              ?.FVehicleName || ""
          } (${fuelChartData[index]?.FuelQty} L)`}
        </text>
      </>
    );
  };
  const renderCustomizedLabel1 = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    percent,
    outerRadius,
    index,
  }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 1.25; // Adjust the radius for label positioning
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    const ishrline = Math.cos(-midAngle * RADIAN) > 0;
    const lineLength = ishrline ? 100 : -100;
    const textOffset = ishrline ? 20 : -20;
    const color = COLORS1[index % COLORS1.length];
    const squareSize = 12;

    // Mock time value for the label
    //   const timeValue = pieChartData[index].time || "00:60"; // Adjust this key if needed

    return (
      <>
        {/* Anchor line */}
        <line
          x1={x}
          y1={y}
          x2={x + lineLength}
          y2={y}
          stroke="#ccc"
          strokeWidth={1}
        />
        <rect
          x={x + lineLength + (ishrline ? -squareSize - 0 : 0)} // Adjust position
          y={y - squareSize / 2} // Center vertically
          width={squareSize}
          height={squareSize}
          fill={color}
        />
        <text
          x={x + lineLength + textOffset}
          y={y}
          fill="#5F6D8C"
          textAnchor={ishrline ? "start" : "end"}
          dominantBaseline="central"
          fontSize={14}
        >
          {`${
            driverChartData[index]?.DATA || ""
          } (${driverChartData[index]?.VAL} L)`}{" "}
        </text>
      </>
    );
  };
  const handleTooltipVisibleChange1 = (visible) => {
    setVisible1(visible);

    if (visible) {
      setTimeout(() => {
        const tooltipArrows = document.querySelectorAll(".ant-tooltip-arrow");
        tooltipArrows.forEach((arrow) => {
          arrow.style.display = "none"; // Hide the arrow
        });
      }, 0);
    }
  };
  const { Option } = Select;
  const { RangePicker } = DatePicker;

  const getFuelReport = async () => {
    setLoading(true);
    const { data } = await CALL_API(
      "GET",
      `aifuel/get_fuel_data?MCID=${userInfo?.MCID}&startDate=${
        dayjs(selectedDate?.[0]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD")
      }&endDate=${
        dayjs(selectedDate?.[1]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD")
      }`,
    );
    setFuelData(data);
    setLoading(false);
  };

  const getFuelChartReport = async () => {
    setLoading(true);
    const { data } = await CALL_API(
      "GET",
      `aifuel/get_fuel_chart?MCID=${userInfo?.MCID}&startDate=${
        dayjs(selectedDate?.[0]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD")
      }&endDate=${
        dayjs(selectedDate?.[1]).format("YYYY-MM-DD") ||
        dayjs().format("YYYY-MM-DD")
      }`,
    );
    setFuelChartData(data?.FuelConsumed);
    setDriverChartData(data?.FuelConsumedDriver);
    setStationChartData(data?.FuelConsumedStation);
    setStationData(data?.FuelConsumedAllStation);
    setLoading(false);
  };

  const formatNumber = (number) => {
    return new Intl.NumberFormat("en-US").format(number || 0);
  };

  const FuelDetailsData = [
    {
      id: "1",
      Name: "Total Litres Fueled",
      values: formatNumber(fuelData["TotalFuel"]?.FuelQty),
    },
    {
      id: "2",
      Name: "Total Cost For Fuel",
      values: `${formatNumber(fuelData["TotalFuelAmount"]?.FuelQty || 0)} KES`,
    },
  ];

  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];

  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getFuelChartReport();
    }
  }, [selectedDate]);

  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getFuelReport();
    }
  }, [selectedDate]);

  useEffect(() => {
    let startDate = null;
    let endDate = null;

    if (duration === "today") {
      startDate = dayjs();
      endDate = dayjs();
    } else if (duration === "current_month") {
      startDate = dayjs().startOf("month");
      endDate = dayjs().endOf("month");
    } else if (duration === "last_month") {
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
    } else if (duration === "current_year") {
      startDate = dayjs().startOf("year");
      endDate = dayjs().endOf("year");
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]);
    }
  }, [duration]);

  return (
    <>
      <Fuelreportstyle>
        <Row gutter={12}>
          <Col sm={24} xl={24} md={24}>
            <Card>
              <div className="total">
                <div>Overview</div>
                <div className="Custom">
                  <div className="dropstyle">
                    {" "}
                    <Form.Item
                      label=""
                      name="dropdown"
                      rules={[
                        { required: true, message: "Please select an option!" },
                      ]}
                    >
                      <Select
                        style={{ width: "240px" }}
                        defaultValue={duration}
                        onChange={(values) => {
                          setDuration(values);
                        }}
                      >
                        {Duration.map((item) => (
                          <Option key={item.value} value={item.value}>
                            {item?.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="dropstyle1">
                    <Space direction="vertical" size={12}>
                      <RangePicker
                        value={selectedDate}
                        onChange={(date, dateString) => setSelectedDate(date)}
                      />
                    </Space>
                  </div>
                </div>
              </div>
            </Card>
          </Col>
          <br />
          <Col sm={24} md={24} bordered={true} className="Fuel-List">
            <Spin spinning={loading}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  textAlign: "center",
                  backgroundColor: "#e3e3e3ff",
                }}
              >
                {FuelDetailsData.map((item, index) => (
                  <div key={index} className="Fuel-detail-item">
                    <Stack direction="horizontal">
                      <div className="text-content">
                        <h6>{item.Name}</h6>
                        <h2>{item.values}</h2>
                        <p>{item.precentage_values}</p>
                      </div>
                      {index < 1 && <div className="vr" />}
                    </Stack>
                  </div>
                ))}
              </div>
            </Spin>
          </Col>
          <br />
          <Col sm={24} md={24} className="mt-3">
            <Spin spinning={loading}>
              <div id="Export Chart">
                <Card bordered={true}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <h6>Fuel Consumed By Vehicle</h6>

                    <img
                      src={upload}
                      alt="Upload Icon"
                      className="hover-image"
                      style={{
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart("Export Chart", "Fuel Report");
                      }}
                    />
                  </div>

                  <ResponsiveContainer width="100%" height={300}>
                    <PieChart width="100%" height={400}>
                      <Pie
                        dataKey="FuelQty"
                        startAngle={180}
                        endAngle={0}
                        data={fuelChartData}
                        cx="50%"
                        cy="80%"
                        outerRadius={200}
                        innerRadius={120}
                        label={renderCustomizedLabel}
                      >
                        {fuelChartData.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>
                      <text
                        x="50%" // Center the text horizontally
                        y="70%" // Center the text vertically
                        textAnchor="middle" // Align text to the middle
                        dominantBaseline="middle" // Center the text vertically
                        fontSize={16} // Adjust font size as needed
                        fill="#5F6D8C"
                      >
                        <tspan
                          x="50%"
                          dy="1rem"
                          style={{
                            fontSize: "40px",
                            color: "#000000ff",
                            fontWeight: "bold",
                          }}
                        >
                          Top 10
                        </tspan>
                      </text>
                    </PieChart>
                  </ResponsiveContainer>
                </Card>
              </div>
            </Spin>
          </Col>
          <Col sm={24} md={24} className="mt-3">
            <div id="Export Chart1">
              <Card bordered={true}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <h6>Fuel Consumed By Driver</h6>
                  <img
                    src={upload}
                    alt="Upload Icon"
                    className="hover-image"
                    style={{
                      cursor: exportAllowed ? "pointer" : "not-allowed",
                    }}
                    onClick={() => {
                      if (!exportAllowed) return;
                      handleDownloadChart(
                        "Export Chart1",
                        "Fuel Consumed By Driver",
                      );
                    }}
                  />
                </div>

                <ResponsiveContainer width="100%" height={300}>
                  <PieChart width="100%" height={400}>
                    <Pie
                      dataKey="FuelQty"
                      startAngle={180}
                      endAngle={0}
                      data={fuelChartData}
                      cx="50%"
                      cy="80%"
                      outerRadius={180}
                      innerRadius={100}
                      label={renderCustomizedLabel1}
                    >
                      {fuelChartData.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS1[index % COLORS1.length]}
                        />
                      ))}
                    </Pie>
                    <text
                      x="50%" // Center the text horizontally
                      y="70%" // Center the text vertically
                      textAnchor="middle" // Align text to the middle
                      dominantBaseline="middle" // Center the text vertically
                      fontSize={16} // Adjust font size as needed
                      fill="#5F6D8C"
                    >
                      <tspan
                        x="50%"
                        dy="1rem"
                        style={{ fontSize: "30px", fontWeight: "bold" }}
                      >
                        Top 10
                      </tspan>
                    </text>
                  </PieChart>
                </ResponsiveContainer>
              </Card>
            </div>
          </Col>
          <Col sm={24} xl={12} md={12} className="mt-3">
            <Card title="Fuel Stations" bordered={true}>
              <StyledTable
                dataSource={stationData}
                columns={FuelsColumn}
                pagination={false}
                scroll={{ x: "max-content", y: 400 }}
              />
            </Card>
          </Col>
          <Col xl={12} sm={24} md={12} className="mt-3">
            <div id="Export Chart2">
              <Card
                title="Top 5 Stations Fueled"
                bordered={true}
                className="custome-card"
                extra={
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "3px",
                    }}
                  >
                    {/* <LeftOutlined style={{ cursor: "pointer" }} />
                  <RightOutlined style={{ cursor: "pointer" }} />
                  <div className="dropstyle1">
                    <Space direction="vertical" size={12}>
                      <RangePicker />
                    </Space>
                  </div> */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                      }}
                    >
                      <img
                        src={upload}
                        alt="Upload Icon"
                        className="hover-image"
                        style={{
                          cursor: exportAllowed ? "pointer" : "not-allowed",
                        }}
                        onClick={() => {
                          if (!exportAllowed) return;
                          handleDownloadChart(
                            "Export Chart2",
                            "Top 5 Stations Fueled",
                          );
                        }}
                      />
                    </div>
                  </div>
                }
              >
                <FuelVerticalChart />
              </Card>
            </div>
          </Col>
        </Row>
      </Fuelreportstyle>
    </>
  );
};

export default FuelReportAI;
